import fetch from '../utils/fetch';
import {ApiURL} from './config';

class UserApi {

    static getAllUsers() {
        return fetch(`${ApiURL}/user`, {
            method: 'GET',
            'Content-Type': 'application/json'
        });
    }

    static getUser(userId) {
        return fetch(`${ApiURL}/user/${userId}`, {
            method: 'GET',
            'Content-Type': 'application/json'
        });
    }

    static store(data) {
        return fetch(`${ApiURL}/user`, {
            method: 'POST',
            body: JSON.stringify(data),
            'Content-Type': 'application/json'
        });
    }

    static update(data) {
        return fetch(`${ApiURL}/user/${data.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            'Content-Type': 'application/json'
        });
    }

    static updatePassword(data) {
        return fetch(`${ApiURL}/user/${data.id}/password`, {
            method: 'PUT',
            body: JSON.stringify(data),
            'Content-Type': 'application/json'
        });
    }
}

export default UserApi;


/** WEBPACK FOOTER **
 ** ./src/api/userApi.js
 **/